import {PHYSICAL} from '../../constants/typePsrs';
import {getMessageQuestionBank, getMessageQuestionBankWarning} from '../bank';

export const getSelectedPsrsNames = (psrsSelectedGroup) => {
  if (!Array.isArray(psrsSelectedGroup)) {
    return '';
  }
  return psrsSelectedGroup.map((psr) => psr.name).join(', ');
};

const hasCodePsr = (psr, listCodePsr, cnpj) => {
  if (psr.isIdMultivanCnpj) {
    return cnpj;
  }

  if (psr.idMultivanPrefix) {
    return psr.idMultivanPrefix + '-';
  }

  let psrItem = listCodePsr.filter((inputPsr) => inputPsr.id === psr.id);

  return psrItem.length ? psrItem[0].idMultivan : '';
};

export const updatePsrsSelected = (psrsSelectedGroup, listCodePsr, cnpj) => {
  let newGroupPsrIdMultivan = [];

  for (let psr in psrsSelectedGroup) {
    newGroupPsrIdMultivan.push({
      id: psrsSelectedGroup[psr].id,
      name: psrsSelectedGroup[psr].name,
      isMigrated: psrsSelectedGroup[psr].isMigrated,
      idMultivanSize: psrsSelectedGroup[psr].idMultivanSize,
      idMultivanSizeMin: psrsSelectedGroup[psr].idMultivanSizeMin,
      idMultivanPrefix: psrsSelectedGroup[psr].idMultivanPrefix,
      idMultivan: hasCodePsr(psrsSelectedGroup[psr], listCodePsr, cnpj)
    });
  }

  return newGroupPsrIdMultivan;
};

const formatListPsrSelectedMessage = (list) =>
  list
    .filter((psrItem) => psrItem?.idMultivan)
    .map((psrItem) => `${psrItem.name}: ${psrItem.idMultivan}`)
    .join(', ');

const createMessagePsrSelected = (psrList) => {
  let listMessages = [];
  let psrListMessage = '';

  psrListMessage = formatListPsrSelectedMessage(psrList);
  listMessages = getMessageQuestionBank(listMessages);
  listMessages = getMessageQuestionBankWarning(listMessages);

  return {listMessages, psrListMessage};
};

export const nextStep = (psrList) => {
  let nextStep = createMessagePsrSelected(psrList);

  return {
    messages: nextStep.listMessages,
    psrList: nextStep.psrListMessage
  };
};

export const getStringWithPsrAcceptedByCnae = (productsCnae) => {
  if (!Array.isArray(productsCnae) || !productsCnae.length) return '';
  return productsCnae.map((product) => product.id).join(',');
};

export const verifyHaveOnlyPsrMigratedSelected = (listCodePsr) => {
  if (!Array.isArray(listCodePsr)) {
    return false;
  }

  let psrsMigratedGroup = listCodePsr.filter((psr) => psr.isMigrated);

  return listCodePsr.length === psrsMigratedGroup.length;
};

export const psrDefineGroupTypes = (psrsGroup) => {
  let psrEcommerce = [];
  let psrPhysical = [];

  if (!Array.isArray(psrsGroup)) {
    return {ecommerce: psrEcommerce, physical: psrPhysical};
  }

  psrsGroup.forEach((psrItem) => {
    if (psrItem.type.code === PHYSICAL) {
      psrPhysical.push(psrItem);
    } else {
      psrEcommerce.push(psrItem);
    }
  });

  return {ecommerce: psrEcommerce, physical: psrPhysical};
};
